export default "__VITE_ASSET__DDqXDZDS__"